module.exports = __webpack_public_path__ + "925dd32f60bc19b707b5a75dfc753c45.png";